import Bus from "@utils/bus.js";

const DB_NAME = "modelList";
const STORE_NAME = "model";

function openModelDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME);

    request.onupgradeneeded = function (e) {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { autoIncrement: true });
      }
    };

    request.onerror = function () {
      reject(request.error || new Error("open indexedDB failed"));
    };

    request.onsuccess = function (e) {
      const db = e.target.result;
      if (db.objectStoreNames.contains(STORE_NAME)) {
        resolve(db);
        return;
      }

      const nextVersion = db.version + 1;
      db.close();

      const upgradeRequest = indexedDB.open(DB_NAME, nextVersion);
      upgradeRequest.onupgradeneeded = function (event) {
        const upgradeDB = event.target.result;
        if (!upgradeDB.objectStoreNames.contains(STORE_NAME)) {
          upgradeDB.createObjectStore(STORE_NAME, { autoIncrement: true });
        }
      };
      upgradeRequest.onerror = function () {
        reject(upgradeRequest.error || new Error("upgrade indexedDB failed"));
      };
      upgradeRequest.onblocked = function () {
        reject(new Error("upgrade indexedDB blocked"));
      };
      upgradeRequest.onsuccess = function (event) {
        resolve(event.target.result);
      };
    };
  });
}

function getModels(cb) {
  openModelDB()
    .then((db) => {
      const models = [];
      const getModelTrans = db.transaction([STORE_NAME], "readonly");
      const getModelReq = getModelTrans.objectStore(STORE_NAME).openCursor();

      getModelReq.onsuccess = function (e) {
        const cursor = e.target.result;
        if (cursor) {
          models.push([cursor.key, cursor.value]);
          cursor.continue();
        }
      };
      getModelReq.onerror = function () {
        console.error("getModels cursor error:", getModelReq.error);
      };
      getModelTrans.oncomplete = function () {
        db.close();
        cb && cb(models);
      };
      getModelTrans.onerror = function () {
        db.close();
        cb && cb([]);
      };
    })
    .catch((err) => {
      console.error("getModels open db error:", err);
      cb && cb([]);
    });
}

function addModel(model, cb) {
  openModelDB()
    .then((db) => {
      const addModelReq = db
        .transaction([STORE_NAME], "readwrite")
        .objectStore(STORE_NAME)
        .add(model);
      addModelReq.onsuccess = function () {
        cb && cb();
        Bus.$emit("indexedDB_changed");
        db.close();
      };
      addModelReq.onerror = function () {
        cb && cb();
        db.close();
      };
    })
    .catch((err) => {
      console.error("addModel open db error:", err);
      cb && cb();
    });
}

function delModel(key, cb) {
  openModelDB()
    .then((db) => {
      const delModelReq = db
        .transaction([STORE_NAME], "readwrite")
        .objectStore(STORE_NAME)
        .delete(key);
      delModelReq.onsuccess = function () {
        cb && cb();
        Bus.$emit("indexedDB_changed");
        db.close();
      };
      delModelReq.onerror = function () {
        cb && cb();
        db.close();
      };
    })
    .catch((err) => {
      console.error("delModel open db error:", err);
      cb && cb();
    });
}

function updateModel(model, key, cb) {
  openModelDB()
    .then((db) => {
      const updateModelReq = db
        .transaction([STORE_NAME], "readwrite")
        .objectStore(STORE_NAME)
        .put(model, key);
      updateModelReq.onsuccess = () => {
        cb && cb();
        Bus.$emit("indexedDB_changed");
        db.close();
      };
      updateModelReq.onerror = () => {
        cb && cb();
        db.close();
      };
    })
    .catch((err) => {
      console.error("updateModel open db error:", err);
      cb && cb();
    });
}

function clearModel(cb) {
  openModelDB()
    .then((db) => {
      const clearModelReq = db
        .transaction([STORE_NAME], "readwrite")
        .objectStore(STORE_NAME)
        .clear();
      clearModelReq.onsuccess = () => {
        cb && cb();
        Bus.$emit("indexedDB_changed");
        db.close();
      };
      clearModelReq.onerror = () => {
        cb && cb();
        db.close();
      };
    })
    .catch((err) => {
      console.error("clearModel open db error:", err);
      cb && cb();
    });
}

function countModels(cb) {
  openModelDB()
    .then((db) => {
      const countModelReq = db
        .transaction([STORE_NAME], "readonly")
        .objectStore(STORE_NAME)
        .count();
      countModelReq.onsuccess = (e) => {
        const num = e.target.result;
        cb && cb(num);
        db.close();
      };
      countModelReq.onerror = () => {
        cb && cb(0);
        db.close();
      };
    })
    .catch((err) => {
      console.error("countModels open db error:", err);
      cb && cb(0);
    });
}

function calculateTotalSizeInM(fileSizes) {
  // 累加数组中的所有文件大小
  const totalSizeInBytes = fileSizes.reduce(
    (acc, fileSize) => acc + (fileSize || 0),
    0,
  );

  // 将字节大小转换成兆字节（1 MB = 1024 * 1024 字节）
  const totalSizeInMegaBytes = totalSizeInBytes / (1024 * 1024);
  // console.log("totalSizeInBytes", totalSizeInMegaBytes);

  return totalSizeInMegaBytes.toFixed(2); // 保留两位小数
}

function getIndexDBSize() {
  return new Promise((resolve) => {
    getModels((res) => {
      const fileSizes = res.map((item) => item[1]?.file?.size || 0);
      const result = calculateTotalSizeInM(fileSizes);
      resolve(result);
    });
  });
}
export default {
  getModels,
  addModel,
  delModel,
  updateModel,
  clearModel,
  countModels,
  getIndexDBSize,
};
